import React, { useState } from 'react';
import { Grid } from '@material-ui/core';
import ACTIONS from 'redux-lib/actions/actions';
import DealName from 'components/edit-section-selects/DealName';
import DealEmail from 'components/edit-section-selects/DealEmail';
import DealPhone from 'components/edit-section-selects/DealPhone';
import ClearBtn from 'components/edit-section-selects/ClearBtn'
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiTextField-root': {
      width: '25ch',
    },
  },
  select: {
    '& .MuiSelect-icon': {
      color: '#3f88b1'
    }
  }
}));

function PersonInfo(props) {
    const classes = useStyles();
    return(
        <div className={ classes.root }>
            <ClearBtn/>
            <DealName/>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <DealEmail/>
                <DealPhone/>
              </Grid>
            </Grid>
        </div>
    )
}

export default PersonInfo;